
import React from "react"
import {MotDePasseComponent} from "./parametre"


export default () => {
    return(
        <>
            <MotDePasseComponent />
        </>
    )

}